export default class SmartCaptcha {
    static render(element, options = {}) {
        const baseOptions = {
            sitekey: SmartCaptcha._clientKey,
            hl: 'ru',
            ...options
        }

        if ('smartCaptcha' in window) {
            return window.smartCaptcha.render(element, baseOptions)
        }

        return undefined
    }

    static init () {
        const nodes = document.querySelectorAll(SmartCaptcha.smartCaptchaSelector)
        nodes.forEach((el) => {
            const id = SmartCaptcha.render(el, {
                callback: (token) => SmartCaptcha.captchaCallback(token, el)
            })
            if (id !== undefined) {
                el.dataset.scWidgetId = String(id)
            }
        })

        document.addEventListener('bxmod:dialog:shown', function (e) {
            const root = (e.detail && e.detail.dialog) ? e.detail.dialog : document;
            const nodes = root.querySelectorAll(SmartCaptcha.smartCaptchaSelector);

            nodes.forEach(function (el) {
                const id = SmartCaptcha.render(el, {
                    callback: (token) => SmartCaptcha.captchaCallback(token, el)
                })
                if (id !== undefined) {
                    el.dataset.scWidgetId = String(id)
                }
            });
        });
    }

    static async captchaCallback(token, el) {
        const checkbox = el ? el.closest('.smartcaptcha-block').querySelector('.js-smart-captcha-input') : null;
        if (checkbox) checkbox.checked = false;

        let ok = false;
        try {
            ok = await SmartCaptcha.validate(token);
        } catch (e) {
            ok = false;
        }

        if (ok) {
            if (checkbox) checkbox.checked = true;
            $(checkbox).trigger('change');
            return;
        }

        if (el && el.dataset && el.dataset.scWidgetId && 'smartCaptcha' in window) {
            window.smartCaptcha.reset(el.dataset.scWidgetId);
        }
    }


    static validate(token) {
        return fetch('/ajax/captcha/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({ token })
        })
            .then(response => response.ok ? response.json() : Promise.reject(new Error('bad response')))
            .then(data => {
                return data && data.valid
            })
            .catch(() => {
                return false
            })
    }
}

SmartCaptcha._clientKey = 'ysc1_fHOjw9aUu0BVLzYeOGciPX3wsCCmGeFJe37RHyPI40ccdab3'
SmartCaptcha._backendCaptchaValidateURL = 'https://decorazza.ru/check-captcha/'
SmartCaptcha.smartCaptchaSelector = '.js-smart-captcha'
